import React from "react";
import Card from "../Card/Card";
import Marquee from "react-fast-marquee";
import { ImSad2 } from "react-icons/im";
import { FaUserTimes } from "react-icons/fa";
import { IoSettings, IoTimeSharp } from "react-icons/io5";
import { HiUserGroup } from "react-icons/hi2";
import { motion } from "framer-motion";

const IsthisForYou = () => {
  return (
    <div className="bg-[#FFE3E3] py-8">
      <div className="text-center pt-6 pb-12">
        <motion.h1
          className="text-3xl lg:text-4xl xl:text-5xl font-bold"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          Is This For You?
        </motion.h1>
        <motion.p
          className="text-black mt-3"
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          This is built for business owners who:
        </motion.p>
      </div>
      <div>
        <Marquee className="flex gap-5">
          <Card
            icon={<ImSad2 fontSize={50} />}
            title={"Overwhelmed"}
            content={"with daily tasks"}
          />
          <Card
            icon={<FaUserTimes fontSize={50} />}
            title={"Outsourcing"}
            content={"didn’t work before"}
          />
          <Card
            icon={<IoTimeSharp fontSize={50} />}
            title={"Spending too much"}
            content={"time managing"}
          />
          <Card
            icon={<HiUserGroup fontSize={50} />}
            title={"Need reliable,"}
            content={"consistent support"}
          />
          <Card
            icon={<IoSettings fontSize={50} />}
            title={"Want systems,"}
            content={"not just assistants"}
          />
        </Marquee>
      </div>
    </div>
  );
};

export default IsthisForYou;
